import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=2794d206"
import script from "./FieldLabel.vue?vue&type=script&lang=ts"
export * from "./FieldLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports